import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import VehicleTypeDrawer from "components/drawer/VehicleTypeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

const VehicleTypeTable = ({
  vehicleCategory,
  perpage,
  currentPage,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  return (
    <>
      <DeleteModal
        id={serviceId}
        body={vehicleCategory.find((item) => item.id === serviceId)}
        title={title}
      />

      <MainDrawer>
        <VehicleTypeDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {vehicleCategory?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data["name"]}
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  title={data["Vehicle Category"]}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  hideDelete={false}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default VehicleTypeTable;
